var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"person":_vm.person,"loading":_vm.loading,"upserting":_vm.upserting,"upsertPerson":_vm.upsertPerson})],2)}
var staticRenderFns = []

export { render, staticRenderFns }